import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { serviceList } from '../data/siteContent';

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = serviceList.find((item) => item.slug === slug);

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-semibold text-charcoal">Service not found</h1>
          <p className="text-gray-500">Explore our main services or start a conversation with the team.</p>
          <Link to="/services" className="text-primary font-semibold">
            Back to services
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-8">
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-gray-500">{service.title}</p>
          <h1 className="text-4xl font-bold text-charcoal mt-2">{service.title}</h1>
          <p className="text-gray-600 mt-4 text-lg leading-relaxed">{service.summary}</p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {service.bullets.map((bullet) => (
            <article key={bullet} className="rounded-2xl border border-primary/20 bg-primary/5 p-5 shadow-sm">
              <p className="text-sm text-charcoal">{bullet}</p>
            </article>
          ))}
        </div>

        <div className="rounded-3xl border border-gray-200 bg-gray-50 p-6">
          <p className="text-sm uppercase text-gray-500">Performance</p>
          <p className="text-2xl font-semibold text-charcoal mt-2">{service.stats}</p>
          <p className="text-gray-600 mt-4">
            Every service is backed by evidence packages, CPA reviews, and a plan to keep your advisors in sync.
          </p>
        </div>

        <div className="flex flex-col gap-4 rounded-3xl border border-primary bg-white p-6 shadow-lg md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-sm uppercase text-gray-500">Next step</p>
            <p className="text-lg font-semibold text-charcoal">Book a strategy assessment</p>
            <p className="text-gray-600 text-sm">Our strategist coordinates with your CPA before implementation.</p>
          </div>
          <Link to="/free-assessment" className="rounded-full bg-primary px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-primary/40">
            Launch assessment
          </Link>
        </div>
      </div>
    </div>
  );
}
